import React, { useEffect, useState } from 'react'
import { useInView } from 'react-intersection-observer'
import useVisible from 'Components/hooks/use-visible'
import get from 'lodash/get'
import ArticleLink from 'Components/links/article-link'

import { sendTeaCommEvent } from 'lib/tea-analyze'
import { Static } from 'react-bootstrap/lib/FormControl'
interface MisData {
  gid: string
  gid_str: string
  title: string
  url: string
  hot: number
  is_video: boolean
}

interface IProps {
  todayNews: MisData[]
}

export default function TodayNews({ todayNews }: IProps) {
  const [ref, inView] = useInView({
    threshold: 0,
  })
  const isVisible = useVisible()
  const [hasShow, setHasShow] = useState(false)
  useEffect(() => {
    if (!hasShow && inView && isVisible && todayNews.length) {
      sendTeaCommEvent('show_home_top_important_news')
      todayNews.forEach((item: MisData, index: number) => {
        sendTeaCommEvent('show_home_important_singel_news', {
          group_id: item.gid,
        })
      })
      setHasShow(true)
    }
  }, [todayNews, inView, isVisible, hasShow])
  return (
    <div className="today-news fl" ref={ref}>
      <div className="box">
        {todayNews.map((item: MisData, index: number) =>
          index !== 0 ? (
            <ArticleLink
              key={item.gid_str}
              className={`today-link`}
              onClick={() => {
                sendTeaCommEvent('click_home_important_singel_news', {
                  group_id: item.gid_str,
                })
              }}
              gid={item.gid_str}
            >
              <div className={`news-title ${item.hot ? 'hot-title' : ''}`}>
                {item.is_video ? <span className="video" /> : ''}
                <span className="name">{get(item, 'title', '')}</span>
              </div>
            </ArticleLink>
          ) : (
            <span className="first-item" key={item.gid_str}>
              <ArticleLink
                className={`today-link first`}
                onClick={() => {
                  sendTeaCommEvent('click_home_important_singel_news', {
                    group_id: item.gid_str,
                  })
                }}
                gid={item.gid_str}
              >
                <div className={`news-title ${item.hot ? 'hot-title' : ''}`}>
                  {item.is_video ? <span className="video" /> : ''}
                  <span className="name">{get(item, 'title', '')}</span>
                </div>
              </ArticleLink>
            </span>
          )
        )}
      </div>
      <style jsx>
        {`
          .today-news {
            width: 380px;
            height: 316px;
            margin-left: 9px;
            overflow: hidden;
            position: absolute;
            right: 0;
          }
          .box {
            width: 380px;
            display: flex;
            flex-wrap: wrap;
            word-break: keep-all;
          }
          .news-title {
            position: relative;
            color: #1f2129;
            font-size: 16px;
            line-height: 1.5;
            padding: 0 7px;
            margin-bottom: 12px;
            display: flex;
            align-items: center;
          }
          .news-title > span.name {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .news-title:before {
            content: '';
            position: absolute;
            display: block;
            left: -1px;
            top: 6px;
            width: 1px;
            height: 12px;
            background: #979aa8;
          }
          .first-item {
            flex: 0 1 100%;
          }
          .first-item .news-title {
            font-size: 18px;
            color: #e65800;
            font-weight: bold;
          }

          .hot-title {
            color: #e65800;
          }

          .news-title:hover {
            color: #e65800;
          }
          .video {
            display: inline-block;
            width: 15px;
            min-width: 15px;
            height: 15px;
            margin-right: 4px;
            background-image: url(${require('static/video-icon.png')});
            background-size: cover;
          }
        `}
      </style>
    </div>
  )
}
